


import React, { useEffect, useState } from 'react';
import styles from "../../assets/scss/MyOeders.module.scss";
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaEye } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import { useGetMyOrdersQuery } from '../../slices/admin/admin';
import { getUserInfo } from '../../utils/user.util';
import { capitalize } from '../../utils/capitalize';

const MyOrders = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    //const offset = (currentPage - 1) + 1;
    const user = getUserInfo();

    const offset = currentPage;

    const { data, isLoading, isError } = useGetMyOrdersQuery({
        offset,
        limit,
        status,
        search: search,
        period: sortBy,
    });

    useEffect(() => {
        setCurrentPage(1);
    }, [search, sortBy, status]);

    const orders = data?.data || [];
    const totalOrders = data?.total || 0;
    const totalPages = Math.ceil(totalOrders / limit);


    const handleClose = () => {
        navigate('/dashboard/CreateOrders');
    };

    return (
        <div className={styles.container}>
            {/* <div className={styles.header}>
                <h2 className={styles.tittle}>My Orders</h2>
                <span className={styles.closeIcon} onClick={handleClose}>✕</span>
            </div> */}

            <div className={styles.main}>
                <div className={styles.filterRow}>
                    <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Search by Order Owner..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <select className={styles.inputs} value={status} onChange={(e) => setStatus(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="accepted">Accepted</option>
                        <option value="movetobilling">Move to Billing</option>
                        <option value="delivered">Delivered</option>
                    </select>
                    <select className={styles.inputs} value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                        <option value="">Sort By</option>
                        <option value="recent">Recent</option>
                        <option value="last7days">Last 7 Days</option>
                        <option value="lastweek">Last Week</option>
                        <option value="lastmonth">Last Month</option>
                    </select>
                    <button className={styles.clearBtn} onClick={() => {
                        setSearch('');
                        setStatus('');
                        setSortBy('');
                        setCurrentPage(1);
                    }}>
                        Clear All
                    </button>
                    {(user?.type === "retailowner" || user?.type === "customer") && (
                        <button className={styles.addBtn} onClick={handleClose}>
                            + Create Orders
                        </button>
                    )}

                </div>

                <div className={styles.tableWrapper}>
                    <table className={styles.orderTable}>
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Order Placed To</th>
                                <th> Pre Order Date</th>
                                <th> Order Date</th>
                                <th>Order Status</th>
                                {/* <th>Delivery Notes</th> */}
                                <th>Delivery Option</th>
                                {/* <th>Assigned To</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan={10}>Loading...</td></tr>
                            ) : isError ? (
                                <tr><td colSpan={10}>Failed to load orders.</td></tr>
                            ) : orders.length === 0 ? (
                                <tr><td className={styles.noData} colSpan={10}>No orders found.</td></tr>
                            ) : (
                                orders.map((order) => (

                                    <tr key={order._id}>
                                        <td className="notranslate">{order.orderId || order._id}</td>
                                        <td>{order.orderStore?.storeName ? capitalize(order.orderStore.storeName) : '-'}</td>
                                        <td>{order.date ? new Date(order.date).toLocaleDateString() : '-'}</td>
                                        <td>{order.items?.[0]?.createdAt ? new Date(order.items[0].createdAt).toLocaleDateString() : '-'}</td>
                                        <td>
                                            <span className={`${styles.status} ${
                                                order.status?.toLowerCase() === "approved" || order.status?.toLowerCase() === "completed" || order.status?.toLowerCase() === "delivered" || order.status?.toLowerCase() === "accepted"
                                                ? styles.statusApproved
                                                : order.status?.toLowerCase() === "pending"
                                                ? styles.statusPending
                                                : order.status?.toLowerCase() === "readyforbilling" || order.status?.toLowerCase() === "readyforpickup" || order.status?.toLowerCase() === "movetobilling"
                                                ? styles.statusWarning
                                                : order.status?.toLowerCase() === "rejected" || order.status?.toLowerCase() === "cancelled"
                                                ? styles.statusRejected
                                                : styles.statusDefault
                                            }`}>
                                                {order.status ? capitalize(order.status) : '-'}
                                            </span>
                                        </td>
                                        {/* <td>{order.notes || '-'}</td> */}
                                        <td>{order.deliveryOption ? capitalize(order.deliveryOption) : '-'}</td>
                                        <td>
                                            {/* <div className={styles.actions}>
                                                <FaEdit
                                                    size={16}
                                                    className={styles.icon}
                                                    onClick={() =>
                                                        navigate('/dashboard/UpdateMyOrder', {
                                                            state: {
                                                                orderId: order._id,
                                                                updateMode: true,
                                                            },
                                                        })
                                                    }
                                                />

                                            </div> */}
                                            <div className={styles.actions}>
                                                {order.status !== "readyforBilling" &&  (
                                                    <FaEdit
                                                        size={16}
                                                        className={styles.icon}
                                                        onClick={() =>
                                                            navigate('/dashboard/UpdateMyOrder', {
                                                                state: {
                                                                    orderId: order._id,
                                                                    updateMode: true,
                                                                },
                                                            })
                                                        }
                                                    />
                                                )}
                                            </div>


                                        </td>
                                    </tr>

                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className={styles.paginationWrapper}>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                    <select
                        className={styles.inputsbtn}
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10 rows</option>
                        <option value={25}>25 rows</option>
                        <option value={50}>50 rows</option>
                    </select>
                </div>
            </div>


        </div>
    );
};

export default MyOrders;
